module.exports = __webpack_public_path__ + "img/banner.447b9914.png";